"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var viewBox = '-0.25 -0.75 14.5 15';

var DeleteCircle = function DeleteCircle() {
  return _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M7.1375,0 C3.1955,0 0,3.196 0,7.1375 C0,11.0795 3.1955,14.2755 7.1375,14.2755 C11.0795,14.2755 14.275,11.0795 14.275,7.1375 C14.275,3.196 11.0795,0 7.1375,0 M7.1375,1.115 C10.4585,1.115 13.16,3.817 13.16,7.1375 C13.16,10.4585 10.4585,13.16 7.1375,13.16 C3.8165,13.16 1.115,10.4585 1.115,7.1375 C1.115,3.817 3.8165,1.115 7.1375,1.115"
  }), _react["default"].createElement("path", {
    d: "M10.6165,9.828 L8.0515,7.263 L10.613,4.702 C10.831,4.484 10.831,4.131 10.613,3.9135 C10.3955,3.6955 10.0425,3.6955 9.8245,3.9135 L7.263,6.4745 L4.702,3.9135 C4.484,3.6955 4.131,3.6955 3.9135,3.9135 C3.6955,4.131 3.6955,4.484 3.9135,4.702 L6.4745,7.263 L3.9135,9.8245 C3.6955,10.0425 3.6955,10.3955 3.9135,10.613 C4.0225,10.722 4.165,10.776 4.3075,10.776 C4.4505,10.776 4.593,10.722 4.702,10.613 L7.263,8.0515 L9.828,10.6165 C9.937,10.7255 10.0795,10.7795 10.222,10.7795 C10.365,10.7795 10.5075,10.7255 10.6165,10.6165 C10.8345,10.399 10.8345,10.046 10.6165,9.828"
  }));
};

var _default = (0, _createSvgIcon["default"])(DeleteCircle, {
  viewBox: viewBox
});

exports["default"] = _default;